import { z } from 'zod';
import { tagId, tagDisplayNameSchema } from '../../types/opaque.mjs';

var Get;
(function (Get) {
    Get.responseSchema = z.object({
        id: tagId,
        displayName: z.string(),
    });
})(Get || (Get = {}));
var GetAll;
(function (GetAll) {
    GetAll.responseSchema = z.array(Get.responseSchema);
})(GetAll || (GetAll = {}));
var Create;
(function (Create) {
    (function (Request) {
        Request.schema = z.object({
            displayName: tagDisplayNameSchema,
        });
    })(Create.Request || (Create.Request = {}));
    Create.responseSchema = z.object({
        id: tagId,
        displayName: z.string(),
    });
})(Create || (Create = {}));
var Update;
(function (Update) {
    (function (Request) {
        Request.schema = z.object({
            displayName: tagDisplayNameSchema,
        });
    })(Update.Request || (Update.Request = {}));
    Update.responseSchema = z.object({
        id: tagId,
        displayName: z.string(),
    });
})(Update || (Update = {}));

export { Create, Get, GetAll, Update };
